export default "__VITE_ASSET__7af2cfca__"